import { FunctionComponent, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Role } from "../../../../context_providers/auth/user_model";
import {
  ToastType,
  useToast,
} from "../../../../context_providers/toast/toast_ctx";
import {
  GetRolesApi,
  DeleteRoleApi,
} from "../../../../service/repos/roles_repo";
import { urls } from "../../../../utils/urls";
import LoadingWidget from "../../../components/loading_spinner";
import Pagination from "../../../new_components/common/pagination";
import Icon from "@mdi/react";
import { mdiHistory } from "@mdi/js";
import DrawerModal, {
  DrawerModalLoaction,
} from "../../../new_components/common/drawer_modal";
import EntityHistory from "../../../../erp/purchase_order/purchase_order_create/components/entity_logs";
import { GetAccessManagementLogsApi } from "../access_logs_repository";

interface RoleTableWidgetProps {}

const RoleTableWidget: FunctionComponent<RoleTableWidgetProps> = (props) => {
  const { showToast } = useToast();
  const history = useHistory();
  const [roles, setRoles] = useState<Role[]>([]);
  const [rolePage, setRolePage] = useState(1);
  const [roleCount, setRoleCount] = useState(50);
  const [roleTotal, setRoleTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState<string>("");
  const [showHistory, setShowHistory] = useState<string>();

  const getRoles = async () => {
    setLoading(true);
    const res = await GetRolesApi({
      count: roleCount,
      page: rolePage,
      search: searchText || undefined,
    });

    if (res.success) {
      setRoles(res.data.data);
      if (res.data.metadata) setRoleTotal(res.data.metadata.total!);
    } else {
      showToast({ type: ToastType.error, text: res.error ?? "" });
    }
    setLoading(false);
  };

  useEffect(() => {
    getRoles();
  }, [rolePage, searchText]);

  const handleClick = (role: Role) => {
    history.push(urls.editRole, role);
  };

  const onDeleteRole = async (role: Role) => {
    const sure = window.confirm(`Are you sure to delete role : ${role.title}`);
    if (!sure) return;
    setLoading(true);
    const res = await DeleteRoleApi(role.id!);

    if (res.success) {
      setRoles((old) => old.filter((r, i) => r.id !== role.id));
      setRoleTotal(roleTotal - 1);
    }
    setLoading(false);
  };

  const heads = ["Role", "History", "Action"];

  return (
    <>
      {showHistory && (
        <DrawerModal
          id="roles_history_drawer"
          location={DrawerModalLoaction.right}
          show={showHistory !== undefined}
          onClose={() => setShowHistory(undefined)}
          title="Role History"
        >
          <EntityHistory
            fetchLogs={({ page, count }) =>
              GetAccessManagementLogsApi({
                entityId: showHistory,
                page,
                count,
              })
            }
          />
        </DrawerModal>
      )}
      <div className=" flex  flex-col justify-start h-screen mx-5">
        <div className="flex justify-between items-center mb-2">
          <h6 className="font-semibold text-lg">Roles/Permissions</h6>
          <input
            id="roles_search"
            type="text"
            value={searchText}
            onChange={(e) => {
              setSearchText(e.target.value);
              setRolePage(1);
            }}
            placeholder="Search roles..."
            className="px-3 py-1 border rounded text-sm w-64"
          />
        </div>
        <div id="roles_table" className=" overflow-auto  " style={{ height: "90%" }}>
          <table className="border divide-y divide-gray-200 relative w-full ">
            <thead className="bg-gray-200 sticky  top-0">
              <tr>
                {heads.map((h) => (
                  <th
                    align="left"
                    key={h}
                    className="px-3 py-2 text-xs font-medium   text-black uppercase tracking-wider"
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200   text-xs">
              {roles.map((role) => {
                //
                return (
                  <tr
                    id={`roles_row_${role.id}`}
                    className="hover:bg-gray-200"
                    key={role.id!}
                    // onDoubleClick={() => props.onTxnClick(txn.id!)}
                  >
                    <td className="px-3 py-2 whitespace-nowrap text-xs font-medium text-gray-900">
                      {role.title}
                    </td>

                    <td className="px-3 py-2 whitespace-nowrap text-center">
                      <div
                        id={`roles_row_${role.id}_history_btn`}
                        className="cursor-pointer flex justify-center"
                        title="History"
                        onClick={() => setShowHistory(role.id)}
                      >
                        <Icon path={mdiHistory} size="16"></Icon>
                      </div>
                    </td>

                    <td align="center" className="flex">
                      <button
                        id={`roles_row_${role.id}_edit_btn`}
                        className="text-blue-300 rounded  hover:text-red-600 mx-1 p-1"
                        onClick={() => handleClick(role)}
                      >
                        Edit
                      </button>
                      <button
                        id={`roles_row_${role.id}_delete_btn`}
                        className="text-blue-300 rounded  hover:text-red-600 mx-1 p-1"
                        onClick={() => onDeleteRole(role)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div id="roles_pagination" className="">
          <Pagination
            itemCount={roles.length}
            page={rolePage}
            total={roleTotal}
            count={roleCount}
            onChange={(p) => {
              setRolePage(p);
            }}
          />
        </div>
      </div>
      <LoadingWidget loading={loading} />
    </>
  );
};

export default RoleTableWidget;
